import Catalog from 'components/Pages/Catalog/Catalog';
import { CatalogQueryDocumentApi, CatalogQueryVariablesApi } from 'graphql/generated';
import { initServerSideProps, ServerSidePropsType } from 'helpers/InitServerSideProps';
import { getServerSidePropsWrapper } from 'helpers/serverSide/getServerSidePropsWrapper';
import { NextPageExtended } from 'types/global';

const CatalogPage: NextPageExtended<ServerSidePropsType> = () => {
    return <Catalog />;
};

CatalogPage.layout = 'withLastVisitedProducts';

export const getServerSideProps = getServerSidePropsWrapper(({ domainConfig, redisClient, t }) => async (context) => {
    return initServerSideProps<CatalogQueryVariablesApi>({
        context,
        domainConfig,
        redisClient,
        t,
        prefetchedQueries: [{ query: CatalogQueryDocumentApi }],
    });
});
export default CatalogPage;
